<div class="modal-filter-container">
  <!-- Filter Trigger Button -->
  <button (click)="onClick()"
    class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-xs font-semibold text-slate-600 dark:text-slate-400 hover:border-slate-300 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-all group">
    <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 group-hover:text-slate-600 dark:text-slate-400 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z"/>
    </svg>
    <span>Filter</span>
    @if (activeFilterCount > 0) {
    <span class="inline-flex items-center justify-center w-4 h-4 rounded-full text-[9px] font-bold text-white bg-primary-800">{{ activeFilterCount }}</span>
    }
  </button>

  @if (isShowFilters) {
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-black/40" style="z-index: 9998" (click)="onClick()"></div>

  <!-- Filter Drawer -->
  <div class="fixed inset-y-0 right-0 w-72 bg-white dark:bg-slate-800 shadow-2xl flex flex-col" style="z-index: 9999" (click)="$event.stopPropagation()">
    <form [formGroup]="formData" class="flex flex-col h-full">

      <!-- Header -->
      <div class="flex items-center justify-between px-5 py-4 flex-shrink-0">
        <h3 class="text-lg font-bold text-slate-900 dark:text-white">Filter</h3>
        <button type="button" (click)="onClick()"
          class="w-8 h-8 flex items-center justify-center bg-primary-800 text-white rounded-lg hover:bg-primary-900 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <hr class="border-slate-200 dark:border-slate-700 flex-shrink-0" />

      <!-- Fields -->
      <div class="flex-1 overflow-y-auto divide-y divide-slate-200 dark:divide-slate-700">

        <!-- Date Range -->
        <div class="px-5 py-4">
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">From Date</label>
              <input type="date" formControlName="startDate" [max]="today"
                class="w-full px-2.5 py-2 border border-slate-300 dark:border-slate-600 rounded-lg text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:border-primary-800 transition-colors" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">To Date</label>
              <input type="date" formControlName="endDate" [max]="today"
                class="w-full px-2.5 py-2 border border-slate-300 dark:border-slate-600 rounded-lg text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:border-primary-800 transition-colors" />
            </div>
          </div>
        </div>

        <!-- Status -->
        <div class="px-5 py-4">
          <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">Status</label>
          <div class="relative">
            <select formControlName="status"
              class="w-full px-2.5 py-2 border border-slate-300 dark:border-slate-600 rounded-lg text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 appearance-none focus:outline-none focus:ring-1 focus:border-primary-800 transition-colors">
              <option value="">All statuses</option>
              @for (opt of statusOptions; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
              }
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-2.5 flex items-center">
              <svg class="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Institution -->
        <div class="px-5 py-4">
          <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">Institution</label>
          <div class="relative">
            <select formControlName="institutionId"
              class="w-full px-2.5 py-2 border border-slate-300 dark:border-slate-600 rounded-lg text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 appearance-none focus:outline-none focus:ring-1 focus:border-primary-800 transition-colors">
              <option value="">All institutions</option>
              @for (inst of institutions; track inst.id) {
              <option [value]="inst.id">{{ inst.name }}</option>
              }
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-2.5 flex items-center">
              <svg class="w-3.5 h-3.5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <!-- Amount Range -->
        <div class="px-5 py-4">
          <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 mb-1.5">Amount Range (₵)</label>
          <div class="grid grid-cols-2 gap-3">
            <input type="number" formControlName="minAmount" placeholder="Min" min="0"
              class="w-full px-2.5 py-2 border border-slate-300 dark:border-slate-600 rounded-lg text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:border-primary-800 transition-colors" />
            <input type="number" formControlName="maxAmount" placeholder="Max" min="0"
              class="w-full px-2.5 py-2 border border-slate-300 dark:border-slate-600 rounded-lg text-xs text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-800 focus:outline-none focus:ring-1 focus:border-primary-800 transition-colors" />
          </div>
        </div>

      </div>

      <!-- Footer -->
      <div class="px-5 py-4 border-t border-slate-200 dark:border-slate-700 flex-shrink-0">
        <button type="button" (click)="onSaveFilters()"
          class="w-full py-2.5 text-sm font-bold text-white bg-primary-800 hover:bg-primary-900 rounded-lg transition-colors">
          Apply Filter
        </button>
        <button type="button" (click)="onResetClick()"
          class="w-full mt-2 py-2 text-xs font-semibold text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:text-slate-300 transition-colors">
          Reset Filters
        </button>
      </div>

    </form>
  </div>
  }
</div>
